import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('your_stripe_publishable_key');

const PlansPage = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [cardNumber, setCardNumber] = useState('');
  const [cardExpiry, setCardExpiry] = useState('');
  const [cardCvc, setCardCvc] = useState('');

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    const stripe = await stripePromise;
  
    const { error, token } = await stripe.createToken({
      card: {
        number: cardNumber,
        exp_month: cardExpiry.split('/')[0],
        exp_year: cardExpiry.split('/')[1],
        cvc: cardCvc,
      },
    });
  
    if (error) {
      console.error(error);
    } else {
      // Send the token to your server to create the subscription
      console.log('Token:', token);
    }
  };
  
  return (
    <div className="container">
      <style>
        {`
          .banner {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px;
          }
          .banner img {
            border-radius: 10px;
          }
        `}
      </style>
      <div className="banner">
        <img src="/planbanner.jpg" alt="Banner" />
      </div>
      <h1>Select a Plan</h1>
      <div className="row">
        <div className="col-md-4">
          <div className={`card ${selectedPlan === '15min' ? 'border-primary' : ''}`}>
            <div className="card-body" onClick={() => handlePlanSelect('15min')}>
              <h5 className="card-title">15 Min for $14.95</h5>
              <ul className="list-unstyled">
                <li>Try It</li>
                <li>Feature 2</li>
                <li>Feature 3</li>
              </ul>
              <button
                type="button"
                className={`btn btn-lg btn-block ${selectedPlan === '15min' ? 'btn-primary' : 'btn-outline-primary'}`}
              >
                {selectedPlan === '15min' ? 'Selected' : 'Select'}
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className={`card ${selectedPlan === '60min' ? 'border-primary' : ''}`}>
            <div className="card-body" onClick={() => handlePlanSelect('60min')}>
              <h5 className="card-title">60 min for $49.95</h5>
              <ul className="list-unstyled">
                <li>Like It</li>
                <li>Feature 2</li>
                <li>Feature 3</li>
              </ul>
              <button
                type="button"
                className={`btn btn-lg btn-block ${selectedPlan === '60min' ? 'btn-primary' : 'btn-outline-primary'}`}
              >
                {selectedPlan === '60min' ? 'Selected' : 'Select'}
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className={`card ${selectedPlan === '120min' ? 'border-primary' : ''}`}>
            <div className="card-body" onClick={() => handlePlanSelect('120min')}>
              <h5 className="card-title">120 min for $99.95</h5>
              <ul className="list-unstyled">
                <li>Can't Live Without It</li>
                <li>Feature 2</li>
                <li>Feature 3</li>
              </ul>
              <button
                type="button"
                className={`btn btn-lg btn-block ${selectedPlan === '120min' ? 'btn-primary' : 'btn-outline-primary'}`}
              >
                {selectedPlan === '120min' ? 'Selected' : 'Select'}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-5">
        <div className="col-md-6">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="cardNumber">Card Number</label>
              <input
                type="text"
                className="form-control"
                id="cardNumber"
                value={cardNumber}
                onChange={(e) => setCardNumber(e.target.value)}
              />
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="cardExpiry">Expiry (MM/YY)</label>
                <input
                  type="text"
                  className="form-control"
                  id="cardExpiry"
                  value={cardExpiry}
                  onChange={(e) => setCardExpiry(e.target.value)}
                />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="cardCvc">CVC</label>
                <input
                  type="text"
                  className="form-control"
                  id="cardCvc"
                  value={cardCvc}
                  onChange={(e) => setCardCvc(e.target.value)}
                />
              </div>
            </div>
            <button type="submit" className="btn btn-primary" disabled={!selectedPlan}>
              Purchase
            </button>
          </form>
        </div>
        <div className="col-md-6">
          {/* Add stripe checkout form */}
          <form action="https://checkout.stripe.com/checkout" method="POST">
            <input type="hidden" name="amount" value="1000" />
            <input type="hidden" name="currency" value="usd" />
            <input type="hidden" name="description" value="Example charge" />
            <input type="hidden" name="stripeToken" value="pk_test_51H" />
            <input type="hidden" name="stripeEmail" value="sph130@gmail.com" />
            <input type="hidden" name="stripeBillingName" value="Sph" />
            <input type="hidden" name="stripeBillingAddressLine1" value="1234 Main St" />
            <input type="hidden" name="stripeBillingAddressZip" value="12345" />
            <input type="hidden" name="stripeBillingAddressState" value="CA" />
            <input type="hidden" name="stripeBillingAddressCountry" value="US" />
            <input type="hidden" name="stripeShippingName" value="Sph" />
            <input type="hidden" name="stripeShippingAddressLine1" value="1234 Main St" />
            <input type="hidden" name="stripeShippingAddressZip" value="12345" />
            <input type="hidden" name="stripeShippingAddressState" value="CA" />
            <input type="hidden" name="stripeShippingAddressCountry" value="US" />
            <button type="submit" className="btn btn-primary" disabled={!selectedPlan}>
              Purchase
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PlansPage;